<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <tfoot
    data-slot="table-footer"
    :class="cn('border-t border-default [&_tr]:h-10 [&_tr:last-child]:border-b-0', props.class)"
  >
    <slot />
  </tfoot>
</template>
